import request from '@core/services/request';

export const lendersAPI = {
	getLenderPartnerId: (fimenu: any, lenderCode: any) => request.post('/Lenders/GetProviderId', { fimenu, lenderCode }),
};
